import { render, staticRenderFns } from "./DiySelect.vue?vue&type=template&id=4f55f604"
import script from "./DiySelect.vue?vue&type=script&lang=js"
export * from "./DiySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports